<template>
  <!-- <header class="border-b-[1px] py-4 hidden sm:block sm:bg-primary sm:mb-4">
    <div class="px-5 py-3 flex items-center justify-between ">
      <h1 class="font-semibold text-white">Nome da Campanha</h1>
      <div>
        <Icon v-if="opened === false" @click="openMenu" name="MenuLogado"/>
        <Icon v-if="opened" @click="openMenu" name="Fechar" class="h-5 w-5"/>
      </div>
    </div>
  </header> -->

  <div class="xl:hidden" v-if="opened">
    <Menu />
  </div>
  <div class="px-5 sm:mb-4 relative">
    <Back state="back"/>

    <figure v-if="showExtras" class="xl:pt-[3vw] sm:mt-8 mt-[10vh] sm:min-h-[20vh] sm:flex sm:items-center">
      <ApplicationSlogan />
    </figure>

    <h2 class="text-3xl font-semibold text-primary sm:px-5 xl:px-24">{{nomeDaPagina}}</h2>
  </div>
</template>

<script>
import ApplicationSlogan from "@/Components/ApplicationSlogan.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Menu from "@/Components/UI/Nav/Menu.vue";
import Back from "@/Components/UI/Back.vue";


export default {
  components: {
    ApplicationSlogan,
    Icon,
    Menu,
    Back,
  },

  props: {
    showExtras: {
      default: false,
      type: Boolean
    },
    showBackButton: {
        default: true,
        type: Boolean
    }
  },
  data() {
    return {
      opened: false
    }
  },
  methods: {
      openMenu() {
        this.opened = !this.opened;
        this.opened ? this.$emit('hiddenContent') : this.$emit('showContent')
    },
  }
};
</script>
